/**
 * LeaveStatusService
 * Service for LeaveStatus entity operations
 * Route: api/leavestatus
 */
import { CrudService } from '../base/CrudService';
/**
 * LeaveStatusService
 * Handles leave status CRUD operations
 */
export class LeaveStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? LeaveStatusService.DEFAULT_SERVICE_PATH,
            basePath: LeaveStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
LeaveStatusService.DEFAULT_SERVICE_PATH = 'hr';
LeaveStatusService.BASE_PATH = 'api/leavestatus';
//# sourceMappingURL=LeaveStatusService.js.map